import React, {useEffect, useState} from 'react'
import Loader from "../../../../../Loader/Loader";
import DashboardMenu from "../../../../layout/dashboardMenu";
import Header from "../../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../../Images/no-data-found.webp";
const LeadPendingList = ({
                            pendingListResponse,
                            pendingListRequest,
                            history
                        }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [filterInputList, setFilterInputList] = useState([{}])
    const [open, setOpen] = useState(false);
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [pageNo, setPage] = useState(1)

    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected+1)
        await pendingListRequest('UCD', val?.selected+1, '', filterInputList)
        setIsLoading(false)
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await pendingListRequest('UCD')
            setIsLoading(false)
        })()
    }, [])

    const handleSearch = async () => {
        if (searchValue === '') {
            return false
        }
        if(searchValue){

        }
        await pendingListRequest('UCD', 1, searchValue, filterInputList)
    }

    const removeSearchFilter = async () => {
        delete window.localStorage.search_lead
        setIsLoading(true)
        await pendingListRequest('UCD')
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await pendingListRequest('UCD', pageNo, '', filterInputList)
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if(key !== ''){
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await pendingListRequest('UCD', pageNo, '', filterInputList)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setFilterInputList([{}])
                setIsLoading(true)
                await pendingListRequest('UCD', pageNo, '')
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Lead List'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between ">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px ">
                                            <form className="form-inline mr-auto w-90 navbar-search">
                                                <div className="d-flex w-100">
                                                    <input type="text"
                                                           className="form-control bg-light border-0 small list-filter"
                                                           placeholder="Search Lead..." aria-label="Search"
                                                           aria-describedby="basic-addon2"
                                                           onChange={(e) => {
                                                               setSearchValue(e.target.value)
                                                           }}
                                                    />
                                                    <div className="remove-search-filter">
                                                        <i className="fa fa-times" aria-hidden="true" onClick={removeSearchFilter}></i>
                                                    </div>
                                                    <div className="btn-search">
                                                        <button className="btn btn-primary lh-32 border-left-tr-tb"
                                                                type="button"
                                                                onClick={(e) => handleSearch()}
                                                        >
                                                            <i className="fas fa-search fa-sm"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        {/*<div className="col-md-6 cs-pos">*/}
                                        {/*    <button onClick={() => setOpen(!open)}*/}
                                        {/*            className="btn btn-sm btn-primary mr-1 btn-filter"*/}
                                        {/*            type="button"><i*/}
                                        {/*        className="fa fa-filter lh-35 pd-3"></i>*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>


                                <div className="row">
                                    {/*CARD START*/}
                                    {pendingListResponse && pendingListResponse?.data !== undefined && pendingListResponse?.data !== [] && pendingListResponse?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    {/*<div className="header-ui-item">*/}
                                                                    {/*    {val?.poc_name}*/}
                                                                    {/*</div>*/}
                                                                    <div className="row">
                                                                        <div className="col-10" style={{
                                                                            color: "#000",
                                                                            fontSize: "20px",
                                                                            textAlign: "left",
                                                                            paddingLeft: "20px"
                                                                        }}>
                                                                            <div className="d-flex">
                                                                                {/*{parseInt(val?.is_draft) === 1 &&*/}
                                                                                {/*    <div className="draft">D&nbsp;&nbsp;</div>*/}
                                                                                {/*}*/}
                                                                                {`${val?.account_name}`}
                                                                                {/*<span*/}
                                                                                {/*    className="ac-type">*/}
                                                                                {/*    {val?.poc_name}*/}
                                                                                {/*</span>*/}
                                                                            </div>

                                                                        </div>
                                                                        {/*<div className="col-2">*/}
                                                                        {/*    /!*TOGGLE*!/*/}
                                                                        {/*    <div className="dropdown"*/}
                                                                        {/*         style={{"float": "right"}}>*/}
                                                                        {/*        <i className="bi bi-three-dots-vertical" data-toggle="dropdown" style={{color:"black"}}></i>*/}
                                                                        {/*        <ul className="dropdown-menu">*/}
                                                                        {/*            <li><a*/}
                                                                        {/*                href={`ucd-lead-activity-list/${val?.id}`}*/}
                                                                        {/*                className="btn btn-sm"*/}
                                                                        {/*                type="button"*/}
                                                                        {/*            >View</a>*/}
                                                                        {/*            </li>*/}
                                                                        {/*        </ul>*/}
                                                                        {/*    </div>*/}
                                                                        {/*</div>*/}
                                                                    </div>
                                                                    <div className="row list-view">
                                                                        {val?.email !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-envelope"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Email
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger" data-tooltip-id="1" title={val?.email}>{val?.email}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {val?.number &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-telephone-fill"></i>&nbsp;&nbsp;Contact No.
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">{val?.number}</div>
                                                                            </div>
                                                                        }

                                                                        {val?.address &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-building"></i>&nbsp;&nbsp;Address
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6">
                                                                                    <span className="trigger" data-tooltip-id="1" title={val?.address}>{val?.address}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <hr/>
                                                                    <div className="row list-view-links">
                                                                        <ul>
                                                                            <li></li>
                                                                            <li>
                                                                                <a
                                                                                    href={`ucd-lead-approval/${val?.id}`}>
                                                                                    <i className="fa fa-tasks"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Action</a>
                                                                            </li>

                                                                        </ul>
                                                                    </div>

                                                                </h6>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                    {pendingListResponse && pendingListResponse?.data !== undefined && pendingListResponse?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(pendingListResponse?.total/pendingListResponse?.per_page)}
                                                forcePage={pendingListResponse?.current_page-1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }
                                    {pendingListResponse  && pendingListResponse?.data !== undefined &&  pendingListResponse?.data.length === 0  &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" alt={""}/>
                                            <div className="text-center" style={{"width":"100%"}}>
                                                Data Not Found
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/*<BottomMenu*/}
                {/*    open={open}*/}
                {/*    setOpen={setOpen}*/}
                {/*    handleSubmitFilter={handleSubmitFilter}*/}
                {/*    filterContent={leadFilter}*/}
                {/*    handleFilter={handleFilter}*/}
                {/*    setIsRemoveFilter={setIsRemoveFilter}*/}
                {/*/>*/}
            </div>
            {/* section ends */}
        </>
    )
}

export default LeadPendingList